import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlus, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import BaseURL from '../assets/contants/BaseURL';
import axios from 'axios';
import Header from '../components/header';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const [formData, setFormData] = useState({
    product_name: '',
    product_id: '',
    weight_unit: 'ton'
  });

  const weightUnitOptions = [
    { value: 'ton', label: 'Ton' },
    { value: 'hours', label: 'Hours' },
    { value: 'liters', label: 'Liters' },
    { value: 'kg', label: 'Kg' },
    { value: 'kWh', label: 'kWh' },
    { value: 'nos', label: 'Nos' }
  ];

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${BaseURL}meters/products/`);
        setProducts(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching products:', error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const filteredProducts = products.filter(product =>
    product.product_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.product_id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSelectedProducts([]);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const currentPageIds = currentItems.map(item => item.id);
      setSelectedProducts(currentPageIds);
    } else {
      setSelectedProducts([]);
    }
  };

  const handleCheckboxChange = (e, productId) => {
    if (e.target.checked) {
      setSelectedProducts([...selectedProducts, productId]);
    } else {
      setSelectedProducts(selectedProducts.filter(id => id !== productId));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const openAddModal = () => {
    setFormData({
      product_name: '',
      product_id: '',
      weight_unit: 'tons'
    });
    setIsAddModalOpen(true);
  };

  const openEditModal = (product) => {
    setCurrentProduct(product);
    setFormData({
      product_name: product.product_name,
      product_id: product.product_id,
      weight_unit: product.weight_unit
    });
    setIsEditModalOpen(true);
  };

  const openDeleteModal = () => {
    if (selectedProducts.length === 0) {
      alert('Please select at least one product to delete');
      return;
    }
    setIsDeleteModalOpen(true);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const productData = {
        ...formData
      };
      const response = await axios.post(`${BaseURL}meters/products/`, productData);
      setProducts([...products, response.data]);
      setIsAddModalOpen(false);
    } catch (error) {
      console.error('Error adding product:', error);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const updateData = {
        ...formData
      };
      await axios.put(`${BaseURL}meters/products/${currentProduct.id}/`, updateData);
      const updatedProducts = products.map(product =>
        product.id === currentProduct.id ? { 
          ...product, 
          ...formData
        } : product
      );
      setProducts(updatedProducts);
      setIsEditModalOpen(false);
    } catch (error) {
      console.error('Error updating product:', error);
    }
  };

  const handleDelete = async () => {
    try {
      await Promise.all(
        selectedProducts.map(id =>
          axios.delete(`${BaseURL}meters/products/${id}/`)
        )
      );

      setProducts(products.filter(product => !selectedProducts.includes(product.id)));
      setSelectedProducts([]);
      setIsDeleteModalOpen(false);

      if (currentItems.length === selectedProducts.length && currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    } catch (error) {
      console.error('Error deleting products:', error);
    }
  };

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <div style={{
        backgroundColor: '#007acc',
        color: 'white',
        alignContent: 'center',
        fontSize: '14px',
        height: '40px'
      }}>
        <Header title="EMS PRODUCTS" />
      </div>

      <div style={{
        border: '1px solid #ccc',
        padding: '10px',
        marginTop: '20px',
        boxShadow: '0 2px 8px rgba(0, 0,  0, 0.1)',
        backgroundColor: 'white',
        margin: '20px auto',
        maxWidth: '1000px',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', width: '30%' }}>
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '8px',
                flex: '1',
                marginRight: '10px',
              }}
            />
            <FontAwesomeIcon
              icon={faSearch}
              style={{ color: '#007acc', cursor: 'pointer' }}
            />
          </div>

          <div style={{ marginLeft: 'auto' }}>
            <button
              style={{
                padding: "10px 15px",
                marginRight: "10px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={openDeleteModal}
              disabled={selectedProducts.length === 0}
            >
              <FontAwesomeIcon icon={faTrash} style={{ marginRight: "5px" }} />
              Delete
            </button>
            <button
              style={{
                padding: "10px 15px",
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                marginRight: '10px',
              }}
              onClick={openAddModal}
            >
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '5px' }} />
              Add
            </button>
          </div>
        </div>
      </div>

      <div style={{
        marginTop: '20px',
        padding: '10px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        maxWidth: '1000px',
        margin: '20px auto',
        marginBottom: '70px',
      }}>
        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
        ) : (
          <>
            <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
              <thead style={{ backgroundColor: '#007acc', color: 'white' }}>
                <tr>
                  <th style={{ padding: "10px", width: '30px' }}>
                    <input
                      type="checkbox"
                      onChange={handleSelectAll}
                      checked={selectedProducts.length > 0 && selectedProducts.length === currentItems.length}
                    />
                  </th>
                  <th style={{ padding: '10px' }}>S.No</th>
                  <th style={{ padding: '10px' }}>Product Name</th>
                  <th style={{ padding: '10px' }}>Product ID</th>
                  <th style={{ padding: '10px' }}>Unit Type</th>
                  <th style={{ padding: "10px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((product, index) => (
                    <tr
                      key={product.id}
                      style={{
                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9',
                      }}
                    >
                      <td style={{ padding: "10px" }}>
                        <input
                          type="checkbox"
                          checked={selectedProducts.includes(product.id)}
                          onChange={(e) => handleCheckboxChange(e, product.id)}
                        />
                      </td>
                      <td style={{ padding: '10px' }}>{indexOfFirstItem + index + 1}</td>
                      <td style={{ padding: '10px' }}>{product.product_name}</td>
                      <td style={{ padding: '10px' }}>{product.product_id}</td>
                      <td style={{ padding: '10px' }}>
                        {weightUnitOptions.find(unit => unit.value === product.weight_unit)?.label}
                      </td>
                      <td style={{ padding: "10px" }}>
                        <FontAwesomeIcon
                          icon={faEdit}
                          style={{ color: "blue", cursor: "pointer", marginRight: '15px' }}
                          onClick={() => openEditModal(product)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ padding: '10px', textAlign: 'center' }}>
                      No products found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  margin: "0 5px",
                  padding: "5px 10px",
                  background: currentPage === 1 ? "#ddd" : "#007acc",
                  color: currentPage === 1 ? "#666" : "#ffffff",
                  border: "1px solid #ddd",
                  borderRadius: "25px",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                }}
              >
                Previous
              </button>

              {[...Array(totalPages).keys()].map((_, i) => (
                <button
                  key={i + 1}
                  onClick={() => handlePageChange(i + 1)}
                  style={{
                    margin: "0 5px",
                    padding: "5px 10px",
                    background: currentPage === i + 1 ? "#007acc" : "#ddd",
                    color: currentPage === i + 1 ? "#ffffff" : "#333",
                    border: "1px solid #ddd",
                    borderRadius: "25px",
                    cursor: "pointer",
                  }}
                >
                  {i + 1}
                </button>
              ))}

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{
                  margin: "0 5px",
                  padding: "5px 10px",
                  background: currentPage === totalPages ? "#ddd" : "#007acc",
                  color: currentPage === totalPages ? "#666" : "#ffffff",
                  border: "1px solid #ddd",
                  borderRadius: "25px",
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                }}
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>

      {isAddModalOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            width: '600px',
          }}>
            <h2>Add Product</h2>
            <form onSubmit={handleAdd}>
              <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                  <label style={{ display: 'block', marginBottom: '5px' }}>Product Name</label>
                  <input
                    type="text"
                    name="product_name"
                    value={formData.product_name}
                    onChange={handleInputChange}
                    style={{ width: '93%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    required
                  />
                </div>
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                  <label style={{ display: 'block', marginBottom: '5px' }}>Product ID</label>
                  <input
                    type="text"
                    name="product_id"
                    value={formData.product_id}
                    onChange={handleInputChange}
                    style={{ width: '93%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    required
                  />
                </div>
              </div>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>Weight Unit</label>
                <select
                  name="weight_unit"
                  value={formData.weight_unit}
                  onChange={handleInputChange}
                  style={{ width: '50%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                >
                  {weightUnitOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px'
              }}>
                <button
                  type="submit"
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    minWidth: '100px'
                  }}
                >
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => setIsAddModalOpen(false)}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    minWidth: '100px'
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isEditModalOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            width: '600px',
          }}>
            <h2>Edit Product</h2>
            <form onSubmit={handleUpdate}>
              <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                  <label style={{ display: 'block', marginBottom: '5px' }}>Product Name</label>
                  <input
                    type="text"
                    name="product_name"
                    value={formData.product_name}
                    onChange={handleInputChange}
                    style={{ width: '93%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    required
                  />
                </div>
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                  <label style={{ display: 'block', marginBottom: '5px' }}>Product ID</label>
                  <input
                    type="text"
                    name="product_id"
                    value={formData.product_id}
                    onChange={handleInputChange}
                    style={{ width: '93%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    required
                  />
                </div>
              </div>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>Weight Unit</label>
                <select
                  name="weight_unit"
                  value={formData.weight_unit}
                  onChange={handleInputChange}
                  style={{ width: '50%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                >
                  {weightUnitOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px'
              }}>
                <button
                  type="submit"
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    minWidth: '100px'
                  }}
                >
                  Update
                </button>
                <button
                  type="button"
                  onClick={() => setIsEditModalOpen(false)}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    minWidth: '100px'
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isDeleteModalOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            width: '400px',
          }}>
            <h2>Confirm Deletion</h2>
            <p>Are you sure you want to delete {selectedProducts.length} selected product?</p>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '10px'
            }}>
              <button
                onClick={handleDelete}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  minWidth: '100px'
                }}
              >
                Delete
              </button>
              <button
                onClick={() => setIsDeleteModalOpen(false)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  minWidth: '100px'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;